<template>
	<div class="py-5" v-if="loading" id="search">
		<div class="loading">
			<div class="ball bg-indigo-400"></div>
			<div class="ball bg-indigo-400"></div>
			<div class="ball bg-indigo-400"></div>
		</div>
	</div>
	<div v-else class="py-5" id="search">
		<div class="justify-center items-center h-32 mt-10 mx-auto mb-20">
			<div class="h-full w-32 mx-auto">
				<!-- <a :href="$route.path"> -->
				<img
					:src="artist.header_image_url"
					class="h-full w-full object-cover cursor-pointer rounded-full"
					alt=""
					v-on:click="home()"
				/>
				<!-- </a> -->
			</div>
			<h1 class="mb-5 text-gray-500 font-bold text-center text-xl">
				{{ artist.name }}
			</h1>
		</div>
		<div class="mt-5 container mx-auto flex-wrap flex">
			<ListAlbum
				:song="song"
				v-for="song in songs"
				v-bind:key="song.id"
			/>
		</div>
		<div class="flex justify-between container mx-auto px-3 mb-5">
			<button
				class="p-2 bg-indigo-400 rounded font-bold text-white"
				id="prev"
				v-if="page !== 1"
				v-on:click="nextDown(page - 1)"
			>
				Prev
			</button>
			<button
				class="p-2 bg-indigo-400 rounded font-bold text-white ml-auto"
				id="next"
				v-if="next !== null"
				v-on:click="nextUp(page + 1)"
			>
				Next
			</button>
		</div>
	</div>
</template>

<script>
import ListAlbum from './listAlbum.vue';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
export default {
	name: 'Artist',
	components: {
		ListAlbum
	},
	data: () => ({
		songs: [],
		loading: true,
		artist: {},
		next: null,
		page: 1
	}),
	mounted() {
		const that = this;
		window.addEventListener('scroll', () => {
			AOS.refresh();
		});
		axios
			.get(
				`https://api.genius.com/artists/${that.$route.params.id}/songs?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU&per_page=50&page=${that.page}`
			)
			.then(async res => {
				that.songs = res.data.response.songs;
				that.next = res.data.response.next_page;
				await axios
					.get(
						`https://api.genius.com/artists/${that.$route.params.id}?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU`
					)
					.then(result => {
						that.artist = result.data.response.artist;
					});
			})
			.finally(() => {
				this.loading = false;
			});
	},
	methods: {
		nextUp: async function(newPage) {
			const that = this;
			this.page++;
			this.loading = true;
			await axios
				.get(
					`https://api.genius.com/artists/${that.$route.params.id}/songs?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU&per_page=50&page=${newPage}`
				)
				.then(async res => {
					that.songs = res.data.response.songs;
					that.next = res.data.response.next_page;
					await axios
						.get(
							`https://api.genius.com/artists/${that.$route.params.id}?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU`
						)
						.then(result => {
							that.artist = result.data.response.artist;
						});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		nextDown: async function(newPage) {
			const that = this;
			this.page--;
			this.loading = true;
			await axios
				.get(
					`https://api.genius.com/artists/${that.$route.params.id}/songs?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU&per_page=50&page=${newPage}`
				)
				.then(async res => {
					that.songs = res.data.response.songs;
					that.next = res.data.response.next_page;
					await axios
						.get(
							`https://api.genius.com/artists/${that.$route.params.id}?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU`
						)
						.then(result => {
							that.artist = result.data.response.artist;
						});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		home: async function() {
			const that = this;
			this.page = 1;
			this.loading = true;
			await axios
				.get(
					`https://api.genius.com/artists/${that.$route.params.id}/songs?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU&per_page=50&page=1`
				)
				.then(async res => {
					that.songs = res.data.response.songs;
					that.next = res.data.response.next_page;
					await axios
						.get(
							`https://api.genius.com/artists/${that.$route.params.id}?access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU`
						)
						.then(result => {
							that.artist = result.data.response.artist;
						});
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>
